import PendoGuide from './PendoGuide';

const PENDO_RATING_GUIDE = 'aca-machinetranslationfeedback';

export default class TranslationFeedbackGuide extends PendoGuide {
    _getGuideName() {
        return this._getGuideNameIfActive(PENDO_RATING_GUIDE);
    }
}